import { elementVersions } from "../config/form_builder/index";
import FormBuilder from "../components/form_builder/FormBuilderArea.vue";
import FormViewer from "../components/form_builder/FormViewer.vue";
import DropArea from "../components/form_builder/FormBuilderElementDropArea.vue";
import FormElementEdit from "../components/form_builder/FormBuilderElementEdit.vue";
import FormElementProperties from "../components/form_builder/FormBuilderElementProperties.vue";
import FormPropertiesManager from "../components/form_builder/FormBuilderElementPropertiesManager.vue";

export default {
  install: Vue => {
    Vue.component("fb-form-builder", FormBuilder);
    Vue.component("fb-form-element-properties", FormElementProperties);
    Vue.component("fb-form-viewer", FormViewer);
    Vue.component("fb-drop-area", DropArea);
    Vue.component("fb-form-element-edit", FormElementEdit);
    Vue.component("fb-form-properties-manager", FormPropertiesManager);

    Object.values(elementVersions).forEach(element => {
      Object.values(element.versions).forEach(version => {
        Vue.component(version.componentName, version.component);
      });
    });
  }
};
